import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'signals-feed-image',
  templateUrl: './feed-image.component.html',
  styleUrls: ['./feed-image.component.scss'],
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedImageComponent {
  @Input()
  public feedImage: string;

  public sanitizedImage: SafeUrl;
}
